import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { find, propEq, defaultTo, equals } from 'ramda';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import FormField from 'containers/FormField';
import FieldSet from 'containers/FieldSetContainer';
import Datepicker from 'components/Datepicker';
import TextFieldBox from 'components/TextFieldBox';
import SelectField from 'components/SelectField';
import ActionButton from 'components/ActionButton';
import TriggerField from 'components/TriggerField';

const typeOpts = [
  { value: 'didNotTake', label: 'medication.opts.didNotTake' },
  { value: 'tookPartOfMedication', label: 'medication.opts.tookPartOfMedication' },
  { value: 'sideEffect', label: 'medication.opts.sideEffect' },
  { value: 'other', label: 'medication.opts.other' },
];

const createEvent = () => ({ timestamp: new Date().valueOf(), done: false });

const renderEvent = editing => (event, i, fields) => {
  const data = fields.get(i);
  const editingThis = !equals(true, data.done);

  return (
    <FieldSet
      key={data.timestamp}
      style={{ margin: '2rem 0' }}
      label={(!editingThis && data.date && moment(data.date).format('DD.MM.YYYY')) || ''}
    >
      <Row>
        <Col xs={8}>
          {editingThis && (
            <Row>
              <Col xs>
                <FormField name={`${event}.date`} component={Datepicker} dateFloorHook="start" />
              </Col>
            </Row>
          )}
          <Row>
            <Col xs>
              <FormField
                name={`${event}.type`}
                component={SelectField}
                isStatic={!editingThis}
                hintLocale="medication.hints.type"
                value={data.type}
                options={typeOpts}
              />
            </Col>
          </Row>
          <Row>
            <Col xs md={8}>
              <FormField
                name={`${event}.detail`}
                component={TextFieldBox}
                isStatic={!editingThis}
                value={data.detail}
                viewStyle={{ fontWeight: '400', width: '120%' }}
                hintLocale="medication.hints.detail"
              />
            </Col>
          </Row>
          {editingThis && (
            <Row style={{ marginTop: '2rem' }}>
              <Col xs={6}>
                <FormField
                  name={`${event}.done`}
                  component={TriggerField}
                  localeId="medication.labels.saveEvent"
                  secondary
                  condensed
                  border
                />
              </Col>
              <Col xs={2}>
                <ActionButton localeId="dictionary.remove" accent condensed onClick={() => fields.remove(i)} />
              </Col>
            </Row>
          )}
        </Col>
        <Col xs={4}>
          {!editingThis && !editing && (
            <FormField
              name={`${event}.done`}
              component={TriggerField}
              setValueTo={false}
              localeId="dictionary.edit"
              accent
              condensed
            />
          )}
        </Col>
      </Row>
    </FieldSet>
  );
};

const renderViewEvents = i => {
  return (
    <div style={{ margin: '2rem 0' }} key={i.timestamp}>
      <Row>
        <Col xs={5}>{i.date && moment(i.date).format('DD.MM.YYYY')}</Col>
        <Col xs>
          <Row>
            <Col xs={8}>
              <Row>
                <Col xs style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                  <FormattedMessage id={find(propEq('value', i.type), typeOpts).label} />
                </Col>
              </Row>
              <Row>
                <Col xs>{i.detail}</Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

const renderEvents = ({ fields, view = false }) => {
  const editing = !view ? find(propEq('done', false), defaultTo([], fields.getAll())) : false;
  return (
    <div>
      {view && fields && fields.map(renderViewEvents)}
      {!view && fields.map(renderEvent(editing))}
      {!view && (
        <FieldSet label="" style={fields.length > 0 ? { marginTop: '5rem' } : {}}>
          {!editing && (
            <ActionButton
              localeId="medication.labels.addNewEvent"
              secondary
              border
              long
              onClick={() => fields.push(createEvent())}
            />
          )}
        </FieldSet>
      )}
    </div>
  );
};

renderEvents.propTypes = {
  fields: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  view: PropTypes.bool,
};

export default renderEvents;
